/**
 * Normalize GET /audit-logs response envelopes to { rows, total, page, limit }.
 * Handles nested `{ data: { data, total } }`, flat `{ data: [] }`, and common alternates.
 *
 * @param {unknown} body - Typically `response.data` from ApiBase.get (axios)
 * @returns {{ rows: unknown[]; total: number; page: number; limit: number }}
 */
export function extractAuditLogListPayload(body) {
  if (body == null || typeof body !== "object") {
    return { rows: [], total: 0, page: 1, limit: 20 };
  }

  const d = body.data;
  const unwrapNestedObject = d != null && typeof d === "object" && !Array.isArray(d);

  const inner = unwrapNestedObject ? d : body;

  if (Array.isArray(inner)) {
    const total = Number(body.total ?? body.meta?.total ?? inner.length) || inner.length;
    const page = Number(body.page ?? body.meta?.page ?? 1);
    const limit = Number(body.limit ?? body.meta?.limit ?? body.perPage ?? (inner.length || 20));
    return {
      rows: inner,
      total: Number.isFinite(total) ? total : inner.length,
      page: Number.isFinite(page) ? page : 1,
      limit: Number.isFinite(limit) ? limit : 20,
    };
  }

  const rows = firstArray(
    inner?.data,
    inner?.items,
    inner?.records,
    inner?.results,
    inner?.auditLogs,
    inner?.logs,
    inner?.rows,
    inner?.list
  );

  const meta = inner?.meta ?? inner?.pagination ?? {};
  const total = Number(inner?.total ?? inner?.count ?? meta.total ?? body.total ?? rows.length);
  const page = Number(inner?.page ?? meta.page ?? body.page ?? 1);
  const limit = Number(inner?.limit ?? meta.limit ?? meta.perPage ?? body.limit ?? 20);

  return {
    rows,
    total: Number.isFinite(total) ? total : rows.length,
    page: Number.isFinite(page) ? page : 1,
    limit: Number.isFinite(limit) ? limit : 20,
  };
}

function firstArray(...vals) {
  for (const v of vals) {
    if (Array.isArray(v)) return v;
  }
  return [];
}
